import { isValidElement, ReactElement, ReactNode } from 'react'

import { IRenderWhenProps, RenderWhen } from 'cng-common/components/renderWhen'

import { MenuItem } from './components/menuItem/MenuItem'
import { MenuItemProps } from './components/menuItem/models'
import { MenuSeparator } from './components/menuSeparator/MenuSeparator'
import { MenuSharedBlock, MenuSharedBlockProps } from './components/menuSharedBlock/MenuSharedBlock'

export const isMenuItem = (child: ReactNode): child is ReactElement<MenuItemProps> => {
  return isValidElement<MenuItemProps>(child) && child.type === MenuItem
}

export const isMenuSeparator = (child: ReactNode): child is ReactElement<MenuItemProps> => {
  return isValidElement<MenuItemProps>(child) && child.type === MenuSeparator
}

export const isMenuSharedItem = (child: ReactNode): child is ReactElement<MenuSharedBlockProps> => {
  return isValidElement<MenuSharedBlockProps>(child) && child.type === MenuSharedBlock
}

export const isConditionItem = (child: ReactNode): child is ReactElement<MenuItemProps> => {
  return isValidElement<IRenderWhenProps>(child) && child.type === RenderWhen
}
